import PropTypes from "prop-types";
import styles from "./EventTicketsInfoList.module.css";
import React from "react";
import { EventTicketsInfo } from "../EventTicketsInfo/EventTicketsInfo";
import { useTranslation } from "react-i18next";

export function EventTicketsInfoList({majorEventsData, header = ""}) {
  const {t} = useTranslation();
  const capitalizeWords = (str) =>
    str.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());
  return (
    <div className={styles.container}>
      <h3>{header}</h3>
      {Object.entries(majorEventsData).map(([eventKey, eventData], index) => (
        <div key={index} className={styles.eventInfo}>
          <EventTicketsInfo
            name={t(capitalizeWords(eventKey))}
            trend={eventData.trend}
            bTotal={eventData.businessesTotal}
            bPaid={eventData.businessesPaid}
            bVIP={eventData.businessesVip}
            bComp={eventData.businessesComp}
            pTotal={eventData.peopleTotal}
            pPaid={eventData.peoplePaid}
            pVIP={eventData.peopleVip}
            pComp={eventData.peopleComp}
            inPerson={eventData.inPerson}
            virtual={eventData.virtual}
          />
        </div>
      ))}
    </div>
  );
}

EventTicketsInfoList.propTypes = {
  list: PropTypes.object.isRequired,
  header: PropTypes.object.isRequired,
};
